export * from './DetailsTemplate_OverviewGrid'


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/DetailsTemplates/index.ts